// URL d'annonce -> opérateur. Une entrée = une page opérateur servie à cette URL exacte
// (comparaison insensible à la casse : /comparer/Bouygues = /comparer/bouygues). Pas de logo de marque.
// primary = couleur des boutons d'appel (tableau « Couleur Primaire (CTA) »), secondary = couleur d'accent.
// site = site officiel de la marque, cité dans l'encadré « Mes Démarches Énergie n'est pas [marque] ».

export const PROVIDERS = {
  "/comparer/orange": { name: "Orange", site: "orange.fr", primary: "#FF7A00" },
  "/comparer/Bouygues": { name: "Bouygues Telecom", site: "bouyguestelecom.fr", primary: "#009CCE", secondary: "#ED7004" },
  "/comparateur/sfr": { name: "SFR", site: "sfr.fr", primary: "#E60000" },
};

// Anciennes URL d'annonces qui affichent la page d'accueil (aucune sur ce site).
export const HOME_ALIASES = [];
